import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'
import { safeAlpha } from '../../../utils/color'

const { color } = tokens
const cardShadow = '0 4px 6px rgba(98, 102, 113, 0.06), 0 2px 2px rgba(98, 102, 113, 0.06)'

export const DashboardEditStyled = styled.div`
  padding: 30px 60px;
  
  .title-container {
    margin-bottom: 24px;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }
  
  /* Barra lateral de grupos y panel de widgets en tarjetas blancas sobre el fondo de la página
     (antes: barra azul oscura y panel gris) */
  .edit-layout {
    display: grid;
    grid-template-columns: minmax(220px, 280px) 1fr;
    gap: 24px;
    align-items: start;
  }

  .edit-card {
    background: ${color.background.default};
    border-radius: 6px;
    box-shadow: ${cardShadow};
  }

  .widgets-sidebar {
    padding: 12px;
  }

  .widgets-groups {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .widgets-group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    padding: 10px 12px;
    font-family: ${tokens.typography.fontFamily.primary};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: ${color.text.secondary};
    background: transparent;
    border: 0;
    border-radius: 6px;
    cursor: pointer;

    :hover {
      background: ${color.background.light};
    }

    &.active {
      font-weight: 500;
      color: ${color.text.primary};
      background: ${props => safeAlpha(props.theme.primary, 0.12)};
    }
  }

  .widgets-group-count {
    flex-shrink: 0;
    min-width: 24px;
    padding: 0 6px;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    color: ${color.text.tertiary};
    background: ${color.background.light};
    border-radius: 999px;
  }

  .widgets-groups-divider {
    height: 1px;
    margin: 8px 0;
    background: ${color.border.subtle};
  }

  .widgets-panel {
    min-width: 0;
  }

  .widgets-panel-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 20px;
    border-bottom: 1px solid ${color.border.subtle};

    h2 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      color: ${color.text.primary};
    }
  }

  .widgets-list {
    max-height: 65vh;
    overflow-y: auto;
    padding: 20px;
  }

  .widgets-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 16px;
  }

  /* Tarjeta de widget: seleccionada con el borde y el check en el color del cliente */
  .widget-card {
    position: relative;
    display: flex;
    align-items: center;
    gap: 16px;
    min-height: 88px;
    padding: 16px;
    font-family: ${tokens.typography.fontFamily.primary};
    text-align: left;
    background: ${color.background.default};
    border: 1.5px solid ${color.border.subtle};
    border-radius: 6px;
    cursor: pointer;
    transition: border-color 0.2s ease, background-color 0.2s ease;

    :hover,
    :focus-visible {
      border-color: ${color.border.default};
      outline: none;
    }

    &.selected {
      border-color: ${props => props.theme.primary};
      background: ${props => safeAlpha(props.theme.primary, 0.04)};
    }
  }

  .widget-check {
    position: absolute;
    top: 8px;
    right: 8px;
    color: ${props => props.theme.primary};
  }

  .widget-image {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 8px;
    background: ${color.background.light};

    img {
      width: 40px;
      height: 40px;
      object-fit: contain;
    }
  }

  .widget-card:not(.selected) .widget-image img {
    filter: grayscale(1);
    opacity: 0.85;
  }

  .widget-name {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: ${color.text.primary};
  }

  @media (max-width: 900px) {
    .edit-layout {
      grid-template-columns: 1fr;
    }
  }

  .MuiSnackbar-root {
    background: #2196f3;
    border-radius: 4px;
    &.success {
      background: #4caf50;
    }
    &.warning {
      background: #ff9800;
    }
    &.error {
      background: #f44336;
    }
    
    .MuiSnackbarContent-root {
      font-size: 1.2em;
      background: inherit;
      cursor: default;
    }
  }
  
`
